export const config = {
    //Set webportal url
    webportalCentraalURL: 'https://webportal.virtuallaundry.net/centraal/service.asmx',

    //The other api URL's are stored inside the webportal store, where webportals are loaded with their ServiceUrl and vlApiUrl

    //In debug mode (ionic serve / npm run serve) a webportal will be added 'localhost debug' for debugging, change these URL's accordingly
    debugServicesUrl: 'http://localhost:55400/Service.svc', //Localhost of Webportal project in the VL_WEB Solution
    debugVlApiUrl: 'http://localhost:5032/1.0/', //Localhost of the VL API
    debugVirtwassWebUrl: 'http://localhost:5173/'
}